import {AbstractControl, UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function uniqueArrayFieldValidator(targetField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof UntypedFormArray)) { return null; }

    const formArray = control as UntypedFormArray;
    const set = new Set<string>();
    for (const arrayControl of formArray.controls) {
      if (!(arrayControl instanceof UntypedFormGroup)) { continue; }
      set.add(arrayControl.controls[targetField].value);
    }

    return set.size === formArray.length ? null : { nonUnique: `Each ${targetField.replace('#{i}', '')} value must be unique`};
  };
}
